const Textarea = ({ id, label, name,value, onChange,defaultView=false, readOnly = false, style = {} }) => (
  <div>
    <label
      className="txtcolor1"
      htmlFor={id}
      style={{
        fontSize: "0.8rem",
        // color: "#212529a6",
        padding: "0.1rem 0.3rem"
      }}
    >
      {label}
    </label>
    <textarea
    className={`form-control p-2 defaulttextareaheight ${readOnly ? "custom-readonly" : ""}`}
      // className="form-control p-2 defaulttextareaheight"
      id={id}
      name={name}
      readOnly={readOnly}
      style={{ fontSize: "0.8rem", ...style }}
      placeholder={label}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default Textarea;
